<template>
  <div class="content">
    <div class="headers ios">
       <img src="@/assets/common/backIcon.png" alt="" @click="go">
    </div>
    <div style="width:100%; height:100%;margin-top:20px;">
      <iframe :src="url" frameborder="0" width="100%" height="100%" id="myIframe"></iframe>
    </div> 
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
name:'easyPay',
data(){
 return{
  url:'',
  name:'',
 }
},
methods: {
  go(){
    this.$router.go(-1)
  }
 
  },
  mounted(){
    this.name=this.$route.params.name
    this.url=this.$route.params.url
    // this.url="https://pay.sfpay.in/index.html?code=02yrs"
    console.log(this.url,'url');
    console.log(this.$route.params.name,'this.$route.params.name');
    const iframe = document.getElementById('myIframe');
    const loadingInstance = Toast.loading(
        {
          message: 'Loading...',
          duration: 0, // 设置为 0 表示持续加载直到手动关闭
          forbidClick: true, // 防止用户点击
          closeOnClick: false // 设置为 true 可以点击关闭 loading
        }
      )
  iframe.addEventListener('load', function() {
  // 当iframe加载完成时触发此逻辑
  loadingInstance.clear()
  // 在这里可以执行其他操作，表示iframe已经加载完成
});
   
  
    if( this.name==='normalExtension'){
      this.$managementEvents({ pageName: 'hot', action: 'everything', extInfo: {  type: 'Total', url: this.url } })
    }else if(this.name==='repaymentExtension'){
      this.$managementEvents({ pageName: 'hot', action: 'everything', extInfo: {  type: 'Delay', url: this.url } })
    }
   
   
  }
}
</script>

<style lang="less" scoped>


.content{
  // overflow: hidden;
  display: flex;
  height: 100vh;
  flex-direction: column;
  align-items: center;
  .headers{
    position: fixed;
    top: 0; /* 将导航栏固定在页面顶部 */
    left: 0;
    z-index: 99;
    background: #4A44C6;
    width: 100%;
    // height: 60px;
    padding: 16px;
    display:flex;
    justify-content: space-between;
    align-items: center;
    &.ios {
      padding-top: calc(var(--app-status-bar-height) + 12px);
    }
    img {
      width: 20px;
      height: 20px;
    }
  }
  
 

}

</style>